export default ({
  members,
  memberPath,
  pagination,
  tableFields = [],
  tableAttrs = {},
  tableSortableFields = [],
  requestFormatter = () => {},
  filteredSearchBar = { show: false },
}) => ({
  members,
  pagination,
  tableFields,
  tableAttrs,
  tableSortableFields,
  memberPath,
  requestFormatter,
  filteredSearchBar,
  showError: false,
  errorMessage: '',
  removeGroupLinkModalVisible: false,
  groupLinkToRemove: null,
  removeMemberModalData: {},
  removeMemberModalVisible: false,
});
